import { ZodError } from "zod";
export const toolRegistry = [];
export async function executeTool(toolName, args, onProgress, onUsage) {
    const tool = toolRegistry.find((t) => t.name === toolName);
    if (!tool) {
        throw new Error(`Unknown tool: ${toolName}`);
    }
    try {
        const validatedArgs = tool.zodSchema.parse(args);
        return tool.execute(validatedArgs, onProgress, onUsage);
    }
    catch (error) {
        if (error instanceof ZodError) {
            const issues = error.issues.map((issue) => `${issue.path.join(".")}: ${issue.message}`).join(", ");
            throw new Error(`Invalid arguments for ${toolName}: ${issues}`);
        }
        throw error;
    }
}
export function getPromptMessage(toolName, args) {
    const tool = toolRegistry.find((t) => t.name === toolName);
    if (!tool?.prompt) {
        throw new Error(`No prompt defined for tool: ${toolName}`);
    }
    const paramStrings = [];
    if (args.prompt) {
        paramStrings.push(args.prompt);
    }
    Object.entries(args).forEach(([key, value]) => {
        if (key !== "prompt" && value !== undefined && value !== null && value !== "false") {
            if (value === "true") {
                paramStrings.push(`[${key}]`);
            }
            else {
                paramStrings.push(`(${key}: ${value})`);
            }
        }
    });
    return `Use the ${toolName} tool${paramStrings.length > 0 ? `: ${paramStrings.join(" ")}` : ""}`;
}
//# sourceMappingURL=registry.js.map